import gql from 'graphql-tag';

export default gql`
  mutation AddFavoriteMeal($mealId: Int!) {
    cookbook {
      addFavoriteMeal(mealId: $mealId) {
        ... on BasicMutationSuccess {
          successCode: code
          __typename
        }
        ... on UnauthorizedException {
          unauthorizedCode: code
          __typename
        }
        ... on Error {
          code
          name
          description
        }
      }
    }
  }
`;
